import { icons } from '@/school-management/utils/icons';
import React from 'react';
import SVG from 'react-inlinesvg';

type AppIconProps = {
  icon: keyof typeof icons;
  size?: number;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
};

const AppIcon: React.FC<AppIconProps> = ({ icon, width, height, size = 30, className, style }) => {
  return (
    <SVG
      src={icons[icon]}
      width={width ?? size}
      height={height ?? size}
      className={className}
      style={style}
    />
  );
};

export default AppIcon;
